import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch";
import debounce from "lodash.debounce";
import { listSpeedLimitCertificateService } from "../service/listSpeedLimitCertificate.service";

const LIMIT = 25;

export const useSpeedLimitCertificateQuery = (filters) => {
  const fetchData = useFetch();
  const [speedLimitCertificates, setSpeedLimitCertificates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchSpeedLimitCertificates = async () => {
      setLoading(true);
      try {
        const response = await listSpeedLimitCertificateService(fetchData)({
          offset: (page - 1) * LIMIT,
          limit: LIMIT,
          ...filters,
        });
        setSpeedLimitCertificates(response.data);
        setTotal(response.total);
        setTotalPages(response.totalPages);
      } catch (error) {
        console.error("Error fetching speed limit certificates:", error);
      } finally {
        setLoading(false);
      }
    };

    const debouncedFetch = debounce(fetchSpeedLimitCertificates, 500);
    debouncedFetch();

    return () => {
      debouncedFetch.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, page, refresh]);

  return {
    speedLimitCertificates,
    loading,
    page,
    onChangePage: (newPage) => setPage(newPage),
    total,
    totalPages,
    refresh: () => setRefresh((prev) => !prev),
  };
};
